import { Currency } from '@godaddy/intl-formatter';
import { cookie } from '@ux/util';
import { CurrencyConstants, DisplayTaxesAndFees, MarketConstants, PeriodUnits } from '../utils/constants';
import { findMatchingPrivacyItem } from '@upp/shared-components/lib/basket/basketHelper';
import '@upp/shared-components/lib/stringHelper';

export const getMarket = () => cookie.get(MarketConstants.COOKIE_KEY) || MarketConstants.DEFAULT_MARKET_KEY ;
export const getCurrency = () => cookie.get(CurrencyConstants.COOKIE_KEY) || CurrencyConstants.DEFAULT_CURRENCY_KEY;

const gdCurrency = new Currency();
export const formatPrice = (market, currency, microunits) => {
  return gdCurrency.formatMicrounits(microunits, market, currency);
};

const getProductPrice = (basketItem, displayTaxesAndFees) => {
  const subtotal = basketItem.pricing.subtotal;
  const fees = basketItem.pricing.fees.icann;
  if (displayTaxesAndFees === DisplayTaxesAndFees.ICANN && fees) {
    return subtotal + fees;
  }
  return subtotal;
};

const calculateGroupPrice = (group, privacyItems, displayTaxesAndFees) => {
  let groupPrivacyTotal = 0;
  const firstGroupItem = group.items[0];
  group.items.map((item) => {
    const privacyItem = findMatchingPrivacyItem(item, privacyItems);
    const itemPrivacyPrice = privacyItem ? privacyItem.pricing.subtotal : 0;
    groupPrivacyTotal += itemPrivacyPrice;
  });
  let groupSubtotal = 0;
  if (firstGroupItem && group.items.length > 1) {
    groupSubtotal = getProductPrice(group, displayTaxesAndFees) + groupPrivacyTotal;
  }
  return groupSubtotal;
};

export const calculatePrice = (itemOrGroup, privacyItems, displayTaxesAndFees) => {
  if (itemOrGroup.items) {
    return calculateGroupPrice(itemOrGroup, privacyItems, displayTaxesAndFees);
  }
  return getProductPrice(itemOrGroup, displayTaxesAndFees);
};

export const getSubtitle = (item) => {
  let subtitle = null;
  if (item.metadata) {
    if (item.metadata.domains) {
      if (item.metadata.domains.length === 1) {
        subtitle = item.metadata.domains[0].domain;
      } else if (item.metadata.domains.length > 1) {
        subtitle = item.metadata.domains.map(d => d.domain).join(', ');
      }
    }
    if (item.metadata.productAttributes) {
      const customMetadata = item.metadata.productAttributes.custom_data
        && item.metadata.productAttributes.custom_data.display_number;
      if (customMetadata) {
        subtitle = customMetadata;
      }
      const extraMetadata = item.metadata.productAttributes.extra_data && item.metadata.productAttributes.extra_data.domain_name;
      if (extraMetadata) {
        subtitle = extraMetadata;
      }
    }
  }
  if (item.commonName) subtitle = item.commonName;
  return subtitle;
};

export const getTermText = (item, language) => {
  let termText = '';
  if (item) {
    const { termMonth, termOneTimeFee, termYear, termMonths, termYears } = language;
    const periodUnit = item.periodUnit;
    const periodDisplay = parseFloat((Math.floor(1000 * item.period) / 1000).toFixed(3));
    if (item.period === 1) {
      if (periodUnit === PeriodUnits.ONE_TIME) {
        termText = termOneTimeFee;
      } else if (periodUnit === PeriodUnits.YEAR) {
        termText = termYear;
      } else if (periodUnit === PeriodUnits.QUARTER) {
        termText = termMonths.format(3);
      } else if (periodUnit === PeriodUnits.SEMI_ANNUAL) {
        termText = termMonths.format(6);
      } else {
        termText = termMonth;
      }
    } else if (periodUnit === PeriodUnits.YEAR) {
      termText = termYears.format(periodDisplay);
    } else {
      termText = termMonths.format(periodDisplay);
    }
  }
  return termText;
};
